var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "详情",
        visible: _vm.visible,
        "append-to-body": true,
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "ac_tabs-contain" },
        [
          _c("div", { staticClass: "title-box" }, [_vm._v("基本信息")]),
          _c(
            "el-descriptions",
            { attrs: { column: 1 } },
            [
              _c("el-descriptions-item", { attrs: { label: "优惠券名称" } }, [
                _vm._v(_vm._s(_vm.info.couponName)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "优惠券id" } }, [
                _vm._v(_vm._s(_vm.info.couponId)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "类型" } }, [
                _vm._v(_vm._s(_vm.info.couponType)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "面值" } }, [
                _vm._v(_vm._s(_vm.info.faceValue)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                _vm._v(_vm._s(_vm.info.couponStatus)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "有效期" } }, [
                _vm._v(_vm._s(_vm.info.date)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "归属礼包" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.info.giftName ? _vm.info.giftName : "-") +
                    "\n      "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "所属供应商" } }, [
                Array.isArray(_vm.info.merchantNameList)
                  ? _c(
                      "div",
                      { staticStyle: { width: "100%" } },
                      _vm._l(_vm.info.merchantNameList, function (merchan) {
                        return _c(
                          "el-tag",
                          {
                            key: merchan,
                            staticStyle: {
                              "margin-right": "5px",
                              "margin-bottom": "5px",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(merchan) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
              ]),
              _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                _vm._v(_vm._s(_vm.info.creatTime)),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "扫码补票是否可用" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.info.driverUser ? "是" : "否") +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "优惠券承担方" } },
                [
                  _vm.info.responsible === 1 ? [_vm._v("三方共补")] : _vm._e(),
                  _vm.info.responsible === 2 ? [_vm._v("平台独补")] : _vm._e(),
                  _vm.info.responsible === 3
                    ? [_vm._v("平台供应商双方共补")]
                    : _vm._e(),
                ],
                2
              ),
              _c("el-descriptions-item", { attrs: { label: "不可用日期" } }, [
                _c(
                  "div",
                  { staticStyle: { width: "100%" } },
                  _vm._l(_vm.disableDateArr, function (tag) {
                    return _c(
                      "el-tag",
                      {
                        key: tag,
                        staticStyle: {
                          "margin-right": "5px",
                          "margin-bottom": "5px",
                        },
                      },
                      [_vm._v("\n            " + _vm._s(tag) + "\n          ")]
                    )
                  }),
                  1
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "title-box" }, [_vm._v("使用")]),
          _c(
            "el-descriptions",
            { attrs: { column: 1 } },
            [
              _c("el-descriptions-item", { attrs: { label: "总发行量" } }, [
                _vm._v(_vm._s(_vm.info.totalNum)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "剩余" } }, [
                _vm._v(_vm._s(_vm.info.remainNum)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "可用业务" } }, [
                _vm._v(_vm._s(_vm.info.bu)),
              ]),
              _c(
                "el-descriptions-item",
                {
                  attrs: {
                    label: "可用线路",
                    contentStyle: { maxHeight: "200px", overflow: "auto" },
                  },
                },
                [_vm._v("\n        " + _vm._s(_vm.info.useLine) + "\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }